import React from 'react';
import styled from 'styled-components';
import { RGBA_COLORS } from '../../utils/colors';

interface LoaderProps {
  color?: string;
  size?: number;
  isFixed?: boolean;
}

export const Spinner: React.FC<LoaderProps> = ({ color = RGBA_COLORS.getAccent(), size = 1, isFixed }) => {
  return <LoaderS />;
};

const LoaderS = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
